<div [style.background-image]="initLogin ? 'url(' + backgroundImageUrl + ')' : null" class="login-page" *ngIf="!token">
  <div class="page-wrap">
    <div class="form-wrapper">
      <div class="form-inner">
        <div class="logo">
          <img [src]="initLogin ? logoImageUrl : null" />
        </div>

        <h2>Log in to your account</h2>
        <form ngNativeValidate (submit)="login()">
          <div class="form-item form-floating mb-3">
            <input
              [(ngModel)]="email"
              name="email"
              type="text"
              class="form-control"
              id="floatingInput"
              placeholder=" "
              required
            />
            <label for="floatingInput">Email Address</label>
          </div>
          <div class="form-item form-floating">
            <input
              [(ngModel)]="pass"
              name="password"
              [type]="showPw ? 'text' : 'password'"
              class="form-control"
              id="floatingPassword"
              placeholder=" "
              required
            />
            <label for="floatingPassword">Password</label>
            <div class="show-pw" (click)="showPassword()">
              <ng-template [ngIf]="showPw">
                <img
                  src="../../../assets/icons/eye.svg"
                  alt="Show password icon"
                />
              </ng-template>
              <ng-template [ngIf]="!showPw">
                <img
                  src="../../../assets/icons/eye-slash.svg"
                  alt="Show password icon"
                />
              </ng-template>
            </div>
          </div>
          <div class="form-item-footer">
            <div class="help">Forgot your password?</div>
            <a [routerLink]="['/forgot-password']" class="link"
              >Retrieve Password</a
            >
          </div>

          <button [style.background-color]="utilityLoginData?.utilityInformation?.color ?? '#000000'" type="submit"
            class="btn login-btn">Login</button>

          <button *ngIf="utilityLoginData.activeDirectoryConfiguration.isEnabled" type="button" class="btn ms-login-btn"
            (click)="loginMicrosoft()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21"><rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/></svg>
            Sign in with Microsoft
          </button>

          <div class="form-item-footer">
            <div class="help">Do you need help?</div>
            <a [routerLink]="['/help']" class="link"
              >Click here</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
  <p class="footer-text">Powered by <span class="bold-text">{{ initLogin
      ? (utilityLoginData?.utilityInformation?.name ?? 'Beacon Power Services')
      : 'Beacon Power Services'
      }}</span></p>
</div>
